import React from "react";
import LOGO from "../../assets/images/LOGO.png";
import Line from "../../assets/images/longBlueLine.png";
import HLine from "../../assets/images/vBlueLine.png";
import { Fade, Flip } from "react-reveal";
const AboutUs = () => {
  return (
    <div className="-mt-20 sm:-mt-8 md:-mt-10 lg:-mt-12 xl:-mt-16 2xl:-mt-24 relative">
      <div className="mx-[2%] lg:mx-[3%] xl:mx-[5%] 2xl:mx-[8%] justify-center items-center shadow-2xl rounded-3xl bg-[#ffffff]">
        {/* <div className="flex justify-center items-center text-sm sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl 2xl:text-6xl">
          <p className="font-['FuturaExtraBold'] text-[#008AC8] mt-2 sm:mt-0 px-1 pt-4 pb-4 sm:pb-6 sm:pt-6 md:pt-8 md:pb-8 lg:pt-12 lg:pb-24 xl:pt-16 xl:pb-28">
            <Fade bottom>For a Green, just and secure present and future.</Fade>
          </p>
        </div> */}
        <div className="sm:grid sm:grid-cols-2 sm:gap-1 pb-1 md:pb-2 lg:pb-3 xl:pb-4">
          <div className="flex flex-col justify-center items-center mt-2 px-1 pt-4 pb-4 sm:pb-6 sm:pt-6 md:pt-8">
            <Flip top>
              <img
                className="h-[50px] sm:h-[70px] md:h-[90px] lg:h-[100px] xl:h-[120px] 2xl:h-[140px] "
                src={LOGO}
                alt="LOGO"
              />
            </Flip>
            {/* <p className="font-['FuturaExtraBold'] text-[#00693A] text-center text-md sm:text-lg md:text-xl lg:text-2xl xl:text-3xl 2xl:text-4xl">
              <Flip cascade top>
                LEBANESE
              </Flip>
            </p>
            <p className="font-['FuturaExtraBold'] text-[#00693A] text-center text-md sm:text-lg md:text-xl lg:text-2xl xl:text-3xl 2xl:text-4xl">
              <Flip cascade top>
                GREEN WAVE
              </Flip>
            </p> */}
            <Fade left>
              <img
                src={Line}
                alt={""}
                className="w-[150px] sm:w-[200px] sm:ml-2 sm:my-1 md:w-[300px] md:ml-2 lg:w-[300px] lg:ml-3 xl:w-[400px] xl:ml-4 xl:my-2 2xl:w-[500px] 2xl:ml-8"
              />
            </Fade>
            <p className="font-['FuturaExtraBold'] text-[#008AC8] text-center text-lg sm:text-xl md:text-2xl lg:text-3xl xl:text-4xl">
              <Flip cascade top>
                ABOUT
              </Flip>
            </p>
            <p className="font-['FuturaExtraBold'] text-[#008AC8] text-center text-4xl sm:text-5xl md:text-6xl lg:text-7xl xl:text-8xl">
              <Flip cascade top>
                US
              </Flip>
            </p>
            <div className="md:my-1 sm:my-0 sm:hidden">
              <img
                src={HLine}
                alt={""}
                className="mt-1 md:mt-2 lg:mt-4 xl:mt-6 2xl:mt-10 h-[35px] "
              />
            </div>
          </div>
          <div className="text-center sm:text-left flex flex-col justify-center items-center mx-12 sm:mx-1 space-y-3 sm:space-y-4 md:space-y-6 lg:space-y-8 xl:space-y-10 2xl:space-y-12">
            <p className="text-black pr-4 sm:pr-8 md:pr-12 lg:pr-16 xl:pr-24 px-1 md:px-2 lg:px-4 xl:px-6 2xl:px-4 text-sm sm:text-md md:text-lg lg:text-xl xl:text-2xl pb-4 md:pb-0">
              {/* The Lebanese Green Wave is an initiative inspired by the Green
              movement and advocating participatory democracy, nonviolence,
              social justice, sustainability, respect for diversity, &
              ecological wisdom. In the Lebanese context, we seek to provide a
              platform for to connect, communicate, and acquire knowledge on
              subjects related to the aforementioned principles. */}
              Green Wave LB joins the green wave across the world in advocating
              climate and social justice, sustainability, respect for diversity
              and ecological wisdom, participatory democracy and nonviolence. We
              give space and provide a platform to connect, communicate, and
              share experience and knowledge.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutUs;
